import { useEffect, useState, useRef } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { useParams } from 'react-router';
import HlsToolBar from 'components/HlsToolbar';
import axios from 'axios';
import LayoutPanel from 'components/LayoutPanel';
const AutoComponent = () => {
  const [buttonState, setButtonState] = useState('');
  const [broadcastId, setBroadcastId] = useState('');
  const [states, setStates] = useState(false);
  const [hlsLink, setHlsLink] = useState('');
  const [condition, setCondtion] = useState(false);
  let { pid, roleName, userName, userId } = useParams();
  const [isScreenSharing, setIsScreenSharing] = useState(false);
  const [sessionId, setSessionId] = useState();
  const [stats, setStats] = useState(null);
  const [streamData, setStreamData] = useState();
  const [count, setCount] = useState();
  const [streams, setStreams] = useState();
  const state = useSelector((state) => state);
  let session;
  let broadcast;
  const subscriberRef = useRef(null);
  const publisherRef = useRef(null);
  let subscriberArray = [];
  const [publisher, setPublisher] = useState(null);
  const [isLoading, setIsLoading] = useState(true);
  const [videoKbps, setVideoKbps] = useState();
  const [audioKbps, setAudioKbps] = useState();
  const [isScreenshareClicked, setIsScreenshareClicked] = useState(false);
  const [currentHost, setCurrentHost] = useState(1);
  useEffect(() => {
    const handleDynamicDivClick = (event) => {
      if (sessionStorage.getItem('broadcastType') === 'manual') {
        sessionStorage.setItem('isHost', true);
        const clickedDynamicDiv = event.target.closest("[id^='OT_']");
        if (clickedDynamicDiv) {
          const dynamicId = clickedDynamicDiv.id;
          console.log('Clicked on div with id:', dynamicId);
          clickedDynamicDiv.classList.toggle('highlight-border');
          // Broadcast the highlight status to other clients

          setStates(true);
          const isHighlighted =
            clickedDynamicDiv.classList.contains('highlight-border');
          console.log('isHighlighted', isHighlighted, dynamicId);
          if (!isHighlighted) {
            for (let sub of subscriberArray) {
              if (sub.id === dynamicId) {
                handleStreamPushed(sub.streamId);
                fetch(
                  `${
                    process.env.REACT_APP_API_URL
                  }/v2/livemeeting/broadcast/removeStream/${sessionStorage.getItem(
                    'broadcastId'
                  )}/${sub.streamId}`,
                  {
                    method: 'POST',
                  }
                )
                  .then((res) => {
                    return res.json();
                  })
                  .then((res) => {
                    console.log(res);
                  })
                  .catch(handleCallback);
              }
            }
          } else {
            for (let sub of subscriberArray) {
              if (sub.id === dynamicId) {
                handleStreamPushed(sub.streamId);
                fetch(
                  `${
                    process.env.REACT_APP_API_URL
                  }/v2/livemeeting/broadcast/addStream/${sessionStorage.getItem(
                    'broadcastId'
                  )}/${sub.streamId}`,
                  {
                    method: 'POST',
                  }
                )
                  .then((res) => {
                    return res.json();
                  })
                  .then((res) => {
                    console.log(res);
                  })
                  .catch(handleCallback);
              }
            }
          }
        }
      }
    };

    // Attach the event listener to the parent div
    const subscriberDiv = subscriberRef.current;
    subscriberDiv.addEventListener('click', handleDynamicDivClick);

    const publisherDiv = publisherRef.current;
    publisherDiv.addEventListener('click', handleDynamicDivClick);

    // Clean up event listener on component unmount
    return () => {
      subscriberDiv.removeEventListener('click', handleDynamicDivClick);
      publisherDiv.removeEventListener('click', handleDynamicDivClick);
    };
  }, []);

  useEffect(() => {
    if (publisher !== null) {
      setIsLoading(false);
    }
  }, [publisher]);

  const handleStreamPushed = (streamId) => {
    if (session) {
      const signalData = JSON.stringify({ streamId });
      session.signal({ type: 'stream-pushed', data: signalData });
    }
  };

  const postSessionId = async (sessionId) => {
    try {
      const userData = JSON.parse(sessionStorage.getItem('userData'));
      const response = await axios.post(
        `${process.env.REACT_APP_API_URL}/v2/video/media/livemeeting/session/${pid}`,
        {
          sessionId,
        },
        {
          headers: {
            Authorization: `Bearer ${userData?.token}`,
          },
        }
      );
      console.log('Success:', response.data);
    } catch (error) {
      console.error('Error:', error);
    }
  };
  useEffect(() => {
    if (!session) {
      fetch(
        `${process.env.REACT_APP_API_URL}/v2/livemeeting/session/${pid}/${userName}/${userId}/${roleName}`,
        {
          method: 'GET',
        }
      )
        .then((res) => {
          return res.json();
        })
        .then((res) => {
          postSessionId(res.sessionId);
          setSessionId(res.sessionId);
          sessionStorage.setItem('sessionId', res.sessionId);
          const apiKey = res.apiKey;
          const sessionId = res.sessionId;
          const token = res.token;
          initializeSession(apiKey, sessionId, token);
        })
        .catch(handleCallback);
    }
  }, []);

  function initializeSession(apiKey, sessionId, token) {
    // Create a session object with the sessionId
    session = window.OT.initSession(apiKey, sessionId);
    console.log(sessionStorage.getItem('isHost'));

    session.on('signal', (event) => {
      let streamId = sessionStorage.getItem('streams');
      let streamIds = JSON.parse(streamId);
      let signalStreamId = JSON.parse(event.data);
      const divId = streamIds.filter(
        (item) => item.streamId === signalStreamId.streamId
      );
      const clickedDynamicDiv = document.getElementById(divId[0].id);

      console.log(clickedDynamicDiv);
      if (
        sessionStorage.getItem('isHost') === false ||
        sessionStorage.getItem('isHost') === null
      ) {
        if (clickedDynamicDiv) {
          // Toggle the highlight class based on the broadcasted data
          // clickedDynamicDiv.classList.toggle('highlight-border');
        }
      }
    });

    window.session = session;
    // Create a publisher
    const publisher = window.OT.initPublisher(
      'publisher',
      {
        videoFilter: {
          type:
            localStorage.getItem('filterPayload') === 'high' ||
            localStorage.getItem('filterPayload') === 'low'
              ? 'backgroundBlur'
              : 'backgroundReplacement',
          backgroundImgUrl: localStorage.getItem('filterPayload'),
        },
        publishAudio: state.waitingRoomReducer.localAudio,
        publishVideo: state.waitingRoomReducer.localVideo,
        fitMode: 'contain',
        insertMode: 'append',
        width: '100%',
        height: '100%',
        resolution: '1280x720',
      },
      handleCallback
    );
    setPublisher(publisher);
    window.publisher = publisher;
    subscriberArray.push(window.publisher);
    // Connect to the session
    session.connect(token, (error) => {
      // If the connection is successful, initialize the publisher and publish to the session
      if (error) {
        handleCallback(error);
      } else {
        session.publish(publisher, handleCallback);
      }
    });

    // Subscribe to a newly created stream
    session.on('streamCreated', (event) => {
      setCurrentHost((x) => x + 1);
      event.stream.videoType === 'screen' && setIsScreenSharing(true);
      const streamContainer =
        event.stream.videoType === 'screen' ? 'hls-screen-share' : 'subscriber';
      window.subscriber = session.subscribe(
        event.stream,
        streamContainer,
        {
          insertMode: 'append',
          width: '100%',
          height: '100%',
        },
        handleCallback
      );
      subscriberArray.push(window.subscriber);
      setCount(subscriberArray.length);
      setStreams(subscriberArray);
      let data =
        subscriberArray &&
        subscriberArray.map((item) => {
          return { streamId: item.streamId, id: item.id };
        });
      sessionStorage.setItem('streams', JSON.stringify(data));
      setCondtion(true);
    });
    session.on('streamDestroyed', (event) => {
      if (event?.stream?.videoType === 'camera') {
        setCount((x) => x - 1);
        setCurrentHost((x) => x - 1);
        setCondtion(false);
        subscriberArray.pop();
      } else {
        setIsScreenSharing(false);
        setCount((x) => x - 1);
        setCurrentHost((x) => x - 1);
        subscriberArray.pop();
      }
    });
  }

  function handleCallback(error) {
    if (error) {
      console.log('error: ' + error.message);
    } else {
      console.log('callback success');
    }
  }
  const handleStartBroadcast = (liveEventUrl) => {
    let streamMode = sessionStorage.getItem('broadcastType');
    fetch(`${process.env.REACT_APP_API_URL}/v2/livemeeting/broadcast/start`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({
        session_id: session.sessionId,
        liveEventUrl,
        streamMode: streamMode ? streamMode : 'auto',
      }),
    })
      .then((res) => {
        return res.json();
      })
      .then((res) => {
        setButtonState('start');
        sessionStorage.setItem('broadcastId', res.broadcast.id);
        setBroadcastId(res.broadcast.id);
        broadcast = res.broadcast.id;
      })
      .catch(handleCallback);
  };

  const handleStopBroadcast = () => {
    sessionStorage.removeItem('broadcastType');
    sessionStorage.removeItem('streamMode');
    sessionStorage.removeItem('screenshareLayout');
    sessionStorage.removeItem('isScreenshareClicked');
    sessionStorage.removeItem('layouts');
    fetch(
      `${
        process.env.REACT_APP_API_URL
      }/v2/livemeeting/broadcast/stop/${sessionStorage.getItem('broadcastId')}`,
      {
        method: 'POST',
      }
    )
      .then((res) => {
        sessionStorage.removeItem('broadcastId');
        return res.json();
      })
      .then((res) => {
        setButtonState('stop');
        sessionStorage.removeItem('streamMode');
        console.log(res);
      })
      .catch(handleCallback);
  };

  useEffect(() => {
    window.addEventListener('message', function (e) {
      const jsonParse = JSON.parse(e.data);
      if (jsonParse.action == 'startBroadcastClick') {
        handleStartBroadcast(jsonParse.liveEventUrl);
      }
      if (jsonParse.action == 'endBroadcastClick') {
        handleStopBroadcast();
      }
    });
  }, []);

  const startScreenSharing = () => {
    const OT = window.OT;
    setIsScreenSharing(true);
    const screenShareDiv = document.getElementById('hls-screen-share');

    screenShareDiv.style.display = 'block';
    let publishOptions = { videoSource: 'screen', width: 900, height: 500 };
    window.hlsScreenShare = OT.initPublisher(
      'hls-screen-share',
      publishOptions,
      function (error) {
        if (error) {
          // Look at error.message to see what went wrong.
          console.log(error);
        } else {
          window.session.publish(window.hlsScreenShare, function (error) {
            if (error) {
              // Look error.message to see what went wrong.
              console.log(error);
            }

            getStreamData(sessionId);
          });
        }
      }
    );
  };

  const stopScreenSharing = () => {
    setIsScreenSharing(false);
    window.session.unpublish(window.hlsScreenShare);
    window.hlsScreenShare.destroy();
    if (window.hlsScreenShare) {
      // Reappend the div in the same position
      let parentDiv = document.querySelector('.d-flex');
      let newScreenShareDiv = document.createElement('div');
      newScreenShareDiv.id = 'hls-screen-share';
      newScreenShareDiv.style.display = 'none';
      newScreenShareDiv.style.height = '500px';
      newScreenShareDiv.className =
        sessionStorage.getItem('broadcastType') === 'manual'
          ? ' screen-share hls-screen-share OT_root OT_publisher OT_fit-mode-contain'
          : 'screen-share hls-screen-share OT_root OT_publisher OT_fit-mode-contain';

      parentDiv.appendChild(newScreenShareDiv);
    }
  };
  const getStreamData = (sessionId) => {
    fetch(
      `${process.env.REACT_APP_API_URL}/v2/livemeeting/broadcast/streamData/${sessionId}`,
      {
        method: 'POST',
      }
    )
      .then((res) => {
        return res.json();
      })
      .then((res) => {
        setStreamData(res);
        console.log(res);
      })
      .catch(handleCallback);
  };

  const handleScreenShareClick = () => {
    let id;
    streamData.response.map((item) => {
      if (item.videoType === 'screen') {
        id = item.id;
      }
    });
    setCurrentHost((x) => x + 1);
    const screenShareDiv = document.getElementById('hls-screen-share');

    if (sessionStorage.getItem('isScreenshareClicked') === 'true') {
      screenShareDiv.classList.add('highlight-border');
      fetch(
        `${
          process.env.REACT_APP_API_URL
        }/v2/livemeeting/broadcast/addStream/${sessionStorage.getItem(
          'broadcastId'
        )}/${id}`,
        {
          method: 'POST',
        }
      )
        .then((res) => {
          return res.json();
        })
        .then((res) => {
          console.log(res);
        })
        .catch(handleCallback);
    } else {
      screenShareDiv.classList.remove('highlight-border');
      fetch(
        `${
          process.env.REACT_APP_API_URL
        }/v2/livemeeting/broadcast/removeStream/${sessionStorage.getItem(
          'broadcastId'
        )}/${id}`,
        {
          method: 'POST',
        }
      )
        .then((res) => {
          return res.json();
        })
        .then((res) => {
          console.log(res);
        })
        .catch(handleCallback);
    }
  };

  useEffect(() => {
    if (streamData && isScreenSharing) {
      handleScreenShareClick();
    }
  }, [streamData, isScreenshareClicked]);
  let previousVideoBytesRate = 0;
  let previousAudioBytesRate = 0;
  useEffect(() => {
    if (publisher) {
      const intervalId = setInterval(() => {
        publisher.getStats((error, statsArray) => {
          if (error) {
            console.error('Failed to get stats:', error);
          } else {
            statsArray && statsArray?.length && setStats(statsArray[0]?.stats);
            let videoBytesKbs =
              ((statsArray[0].stats.video.bytesSent - previousVideoBytesRate) *
                8) /
              1000;
            previousVideoBytesRate = statsArray[0].stats.video.bytesSent;
            setVideoKbps(videoBytesKbs);

            let audioBytesKbs =
              ((statsArray[0].stats.audio.bytesSent - previousAudioBytesRate) *
                8) /
              1000;
            previousAudioBytesRate = statsArray[0].stats.audio.bytesSent;
            setAudioKbps(audioBytesKbs);
          }
        });
      }, 1000);

      return () => clearInterval(intervalId);
    }
  }, [publisher]);

  const handleScreenshareClicked = () => {
    if (sessionStorage.getItem('broadcastType') === 'manual') {
      if (sessionStorage.getItem('isScreenshareClicked') === 'true') {
        sessionStorage.setItem('isScreenshareClicked', 'false');
        setIsScreenshareClicked(false);
      } else {
        sessionStorage.setItem('isScreenshareClicked', 'true');
        setIsScreenshareClicked(true);
      }
    }
  };

  useEffect(() => {
    const interval = setInterval(() => {
      if (sessionStorage.getItem('broadcastId')) {
        const requestOptions = {
          method: 'POST',
          redirect: 'follow',
        };

        fetch(
          `${
            process.env.REACT_APP_API_URL
          }/v2/livemeeting/broadcast/status/${sessionStorage.getItem(
            'broadcastId'
          )}`,
          requestOptions
        )
          .then((response) => response.json())
          .then((result) => {
            if (result?.broadcastUrls?.rtmp[0]?.status === 'live') {
              window.parent.postMessage(
                { type: 'BROADCAST_STATUS', data: result },
                '*'
              );
              clearInterval(interval);
            }
          })
          .catch((error) => console.error(error));
      }
    }, 2000);

    return () => clearInterval(interval);
  }, []);
  console.log('inside auto');
  return (
    <>
      <main className={`${condition ? 'custom-row' : ''} hls-main`}>
        <div
          className={`${
            condition || isScreenSharing ? 'parent-hls test3' : ''
          } d-flex`}
        >
          <div
            className={`hls-publisher ${`${
              count > 3 || currentHost > 3 ? 'threepublisher' : ''
            }`} test1 ${isScreenSharing ? 'width-main-screenshare' : ''} ${
              count > 2 && !isScreenSharing ? 'hls-main-width' : ''
            } ${count == 2 && !isScreenSharing ? 'host-main' : ''}`}
            style={{
              display: 'flex',
              width: `${
                isScreenSharing ? '100% !important' : '30% !important'
              }`,
              justifyContent: 'center',
            }}
          >
            <div
              ref={publisherRef}
              id='publisher'
              className={`publisher test2 ${
                count == 2 && isScreenSharing ? 'host-publisher' : ''
              } ${isScreenSharing && !condition ? 'firstDiv' : ''}`}
              style={{ height: '90vh', width: '60%' }}
            ></div>
            <div
              ref={subscriberRef}
              id='subscriber'
              className='subscriber'
              style={{
                display:
                  isScreenSharing && !condition && currentHost > 3
                    ? 'none'
                    : `${count >= 3 ? 'flex' : 'block'}`,
                flexDirection:
                  isScreenSharing && !condition
                    ? ''
                    : `${count >= 3 ? 'column' : ''}`,
              }}
            ></div>
          </div>
          <div
            onClick={() => handleScreenshareClicked()}
            style={{
              display: `${isScreenSharing ? 'block' : 'none'}`,
              height: '500px',
            }}
            id='hls-screen-share'
            className={`screen-share hls-screen-share OT_root OT_publisher OT_fit-mode-contain`}
          ></div>
        </div>
        {!isLoading && (
          <div className='hls-toolbar'>
            <HlsToolBar
              isScreenSharing={isScreenSharing}
              startScreenSharing={startScreenSharing}
              stopScreenSharing={stopScreenSharing}
              hlsData={window.session && window.session}
              OT={window.OT}
              Publisher={publisher}
              session={window.session}
              stats={stats}
              videoKbps={videoKbps}
              audioKbps={audioKbps}
            />
          </div>
        )}
      </main>
    </>
  );
};
export default AutoComponent;
